<template>
  <b-row v-show="showLoading && processingGIF">
    <b-col class="text-center">
      <img alt="Processing..." :class="classes" :src="processingGIF" />
      <h4 v-if="currentProcessingMessage">{{currentProcessingMessage}}</h4>
    </b-col>
  </b-row>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import {ActionMessages, MessageDisplayTime} from '@/constants'

export default {
  name: 'ProcessingGif',
  props: {
    classes: {
      type: String,
      default: 'processing-image'
    },
    processing: {
      type: Boolean,
      default: undefined
    },
    useActionMessages: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      currentProcessingMessage: null,
      timerId: null
    }
  },
  computed: {
    ...mapState(['isLoading']),
    ...mapGetters(['processingGIF']),
    showLoading: function() {
      if (this.processing !== undefined) {
        return this.processing
      }
      return this.isLoading
    }
  },
  mounted() {
    this.$root.$on('toggle-processing-gifs', (customMessages, actions = null) => {
      if (this.timerId) {
        clearTimeout(this.timerId)
        this.timerId = null
      }

      let messages = customMessages || []

      if (actions && actions.length) {
        actions.forEach(action => {
          messages = messages.concat(ActionMessages[action])
        })
      }

      if (messages.length) {
        const displayMessage = (index) => {
          this.currentProcessingMessage = messages[index]

          if ((index + 1) < messages.length) {
            this.timerId = setTimeout(() => {
              displayMessage(index + 1)
            }, MessageDisplayTime)
          }
        }
        displayMessage(0)
      } else {
        this.currentProcessingMessage = null
      }
    })
  },
  beforeDestroy() {
    this.$root.$off('toggle-processing-gifs')
    this.currentProcessingMessage = null

    if (this.timerId) {
      clearTimeout(this.timerId)
      this.timerId = null
    }
  }
}
</script>

<style scoped>

</style>
